import Store from "../../../../Store/Store";

class UnitStatusTypeContainer {
  public pickIdFromLabel(label) {
    const UnitStatusTypes = Store.getConfigurator().getState().globalTypes?.UnitStatus

    for (const type in UnitStatusTypes) {
      if (UnitStatusTypes[type].label.toLowerCase() === label.toLowerCase()) {
        return UnitStatusTypes[type].id
      }
    }
  }

  public pickLabelFromId(id) {
    const UnitStatusTypes = Store.getConfigurator().getState().globalTypes?.UnitStatus

    for (const type in UnitStatusTypes) {
      if (UnitStatusTypes[type].id === id) {
        return UnitStatusTypes[type].label
      }
    }
  }
}

export default new UnitStatusTypeContainer();
